
import { updateConfig } from '../base/config';
import { SET_AUDIO_MUTED, SET_VIDEO_MUTED } from '../base/media';
import { MiddlewareRegistry } from '../base/redux';
import { updateSettings } from '../base/settings';
import {
    TRACK_ADDED,
    TRACK_NO_DATA_FROM_SOURCE,
    getLocalTracks,
    replaceLocalTrack
} from '../base/tracks';
import { getBackendSafeRoomName } from '../base/util';

import { PREJOIN_START_CONFERENCE } from './actionTypes';
import {
    setDeviceStatusOk,
    setDeviceStatusWarning,
    setPrejoinJoinError,
    setPrejoinPageVisibility
} from './actions';
import { isPrejoinPageVisible } from './functions';

declare var APP: Object;


/**
 * The redux middleware for {@link PrejoinPage}.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => async action => {
    switch (action.type) {
    case PREJOIN_START_CONFERENCE: {
        const { getState, dispatch } = store;
        const state = getState();
        const { userSelectedSkipPrejoin } = state['features/prejoin'];
        const roomName = getBackendSafeRoomName(state['features/base/conference'].room);
        const localTracks = getLocalTracks(state['features/base/tracks']);
        const { options } = action;

        dispatch(setPrejoinJoinError(''));

        APP.conference.prejoinConnect(roomName);

        setTimeout(async () => {
            options && store.dispatch(updateConfig(options));

            userSelectedSkipPrejoin && dispatch(updateSettings({
                userSelectedSkipPrejoin
            }));

            // Do not signal audio/video tracks if the user joins muted.
            for (const track of localTracks) {
                if (track.muted) {
                    await dispatch(replaceLocalTrack(track.mhTrack, null));
                }
            }

            // Only the tracks that survived the loop above. Replacing a track with null disposes it, so passing
            // the whole pre-loop snapshot on to the conference handed it tracks that were already disposed, and
            // the join then failed to add them with 'track.track_is_disposed'.
            const mhTracks = localTracks.filter(track => !track.muted).map(track => track.mhTrack);

            dispatch(setPrejoinPageVisibility(false));
            APP.conference.prejoinStart(mhTracks);
        }, 500);

        break;
    }

    case SET_AUDIO_MUTED: {
        if (isPrejoinPageVisible(store.getState())) {
            store.dispatch(updateSettings({
                startWithAudioMuted: Boolean(action.muted)
            }));
        }
        break;
    }

    case SET_VIDEO_MUTED: {
        if (isPrejoinPageVisible(store.getState())) {
            store.dispatch(updateSettings({
                startWithVideoMuted: Boolean(action.muted)
            }));
        }
        break;
    }

    case TRACK_ADDED:
    case TRACK_NO_DATA_FROM_SOURCE: {
        const state = store.getState();

        if (isPrejoinPageVisible(state)) {
            const { track: { mhTrack: track } } = action;
            const { deviceStatusType, deviceStatusText } = state['features/prejoin'];

            if (!track.isAudioTrack()) {
                break;
            }

            if (track.isReceivingData()) {
                if (deviceStatusType === 'warning'
                    && deviceStatusText === 'prejoin.audioDeviceProblem') {
                    store.dispatch(setDeviceStatusOk('prejoin.lookGood'));
                }
            } else if (deviceStatusType === 'ok') {
                store.dispatch(setDeviceStatusWarning('prejoin.audioDeviceProblem'));
            }
        }
        break;
    }

    }

    return next(action);
});
